import { gql } from "@apollo/client";

import { GRAPHQL_METHODS } from "../../utils/constants";
import { dateToISO } from "../../utils/dates";
import { networkGraphqlRequest } from "../../utils/networkUtils";

const SAVE_PROCESS = gql`
  mutation submitProcess($cmd: SaveProcessCmd!) {
    saveProcess(cmd: $cmd)
  }
`;

export function requestDataProcess(client, clients, complaintId, processInfo) {
  const clientType = clients.map((type) => {
    return {
      client: type.value,
      clientName: type.inputValue,
    };
  });

  const params = {
    cmd: {
      caseNumber: complaintId,
      clientType: clientType,
      areasInvolved: processInfo.involvedAreas,
      areasAffected: processInfo.affectedAreas,
      loadType: processInfo.loadType,
      loadContent: processInfo.label,
      commercialExecutive: processInfo.executiveName,
      videoSurveillance: processInfo.requestVideo,
      dateRequestVideo: processInfo.videoRequestDate
        ? dateToISO(processInfo.videoRequestDate)
        : null,
      dateReceptionVideo: processInfo.videoUploadDate
        ? dateToISO(processInfo.videoUploadDate)
        : null,
      reviewProcess: processInfo.requestVideo
        ? parseInt(processInfo.processNumber)
        : null,
      incidence: processInfo.isIncidence,
      incidenceDate: processInfo.incidenceDate
        ? dateToISO(processInfo.incidenceDate)
        : null,
      dateRequestTraceability: processInfo.traceabilityRequestDate
        ? dateToISO(processInfo.traceabilityRequestDate)
        : null,
      dateDeliveryTraceability: processInfo.traceabilityDeliveryDate
        ? dateToISO(processInfo.traceabilityDeliveryDate)
        : null,
      dateAnswerSent: processInfo.responseDate
        ? dateToISO(processInfo.responseDate)
        : null,
    },
  };
  return networkGraphqlRequest(
    GRAPHQL_METHODS.MUTATION,
    client,
    SAVE_PROCESS,
    params
  );
}
